'use client';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { AppSidebar } from '@/app/(app)/sidebar/sidebar';
import { CommandMenu } from '@/components/command-menu';
import { AuthProvider } from '@/components/providers/auth-provider';
import { EmployeesProvider } from '@/components/providers/employee-provider';
import { ModulesProvider } from '@/components/providers/modules-provider';
import { RecentlyVisitedProvider } from '@/components/providers/recently-visited-provider';
import { ServiceTypeTemplatesProvider } from '@/components/providers/service-templates-provider';
import { ApiV1Provider } from '@/components/providers/v1-api';
import { CustomerProvider } from '@/components/providers/v1-cutsomer-provider';
import { EmployeeMeProvider } from '@/components/providers/v1-me-provider';
import { OfficeProvider } from '@/components/providers/v1-office-provider';
import { VersionUpdater } from '@/components/providers/version-updater';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <ApiV1Provider>
        <EmployeeMeProvider>
          <OfficeProvider>
            <ModulesProvider>
              <EmployeesProvider>
                <CustomerProvider>
                  <ServiceTypeTemplatesProvider>
                    <RecentlyVisitedProvider>
                      <SidebarProvider>
                        <AppSidebar />
                        <SidebarInset>{children}</SidebarInset>
                        <ReactQueryDevtools initialIsOpen={false} />
                        <CommandMenu />
                      </SidebarProvider>
                    </RecentlyVisitedProvider>
                  </ServiceTypeTemplatesProvider>
                </CustomerProvider>
              </EmployeesProvider>
            </ModulesProvider>
          </OfficeProvider>
        </EmployeeMeProvider>
        <VersionUpdater />
      </ApiV1Provider>
    </AuthProvider>
  );
}
